function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from 'prop-types';
import _classnames from 'classnames';
export default {
  propTypes: {
    textColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    colorVariant: PropTypes.oneOf(['light', 'dark'])
  },
  defaultProps: {
    textColor: undefined,
    backgroundColor: undefined,
    colorVariant: undefined
  },
  classnames: function classnames(props) {
    var _classnames2;

    return _classnames((_classnames2 = {}, _defineProperty(_classnames2, "has-text-".concat(props.textColor), props.textColor), _defineProperty(_classnames2, "has-background-".concat(props.backgroundColor), props.backgroundColor), _defineProperty(_classnames2, "is-".concat(props.colorVariant), props.colorVariant), _classnames2));
  },
  clean: function clean(_ref) {
    var textColor = _ref.textColor,
        backgroundColor = _ref.backgroundColor,
        colorVariant = _ref.colorVariant,
        props = _objectWithoutProperties(_ref, ["textColor", "backgroundColor", "colorVariant"]);

    return props;
  }
};